module.exports = __webpack_public_path__ + "media/3.5ea54c5c.mp3";